export default __webpack_public_path__ + "static/media/logo_expanded.05db6e10.svg";